<template>
  <div :class="$style.select">
    <div @click="select" class="yw-select-wrap">
      <span>{{selectVal || placeholder}}</span>
      <i class="iconfont yw-shixinjiantou-xiangshang-copy"></i>
    </div>
    <ul :class="`${$style.drop} ${active && $style.active} yw-select-drop`">
      <li 
        v-for="(item, index) in options" 
        :key="index" 
        @click="change(item)"
        :class="`${value === item.value}`"
      >{{item.text}}</li>
      <span v-if="!options.length">{{ hint }}</span>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    options: {
      default: () => []
    },
    placeholder: {
      default:""
    },
    hint: {
      default: ""
    }
  },
  data () {
    return {
      active: false
    };
  },
  components: {
    
  },
  computed: {
    selectVal() {
      const val = this.options.find(item => item.value === this.value)
      return (val && val.text) || this.value
    }
  },
  methods: {
    select() {
      this.active = !this.active;
      this.$emit('select', this.active)
    },
    change(item) {
      this.$emit('change', item);
      this.active = !this.active;
    },
    reset() {
      this.active = false;
    }
  }
}
</script>

<style lang="scss" module>
.select {
  position: relative;
  > div:nth-child(1) {
    width: 125px;
    height: 32px;
    border:1px solid #e6e6e6;
    line-height:32px;
    padding: 0 15px 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    :global {
      .yw-shixinjiantou-xiangshang-copy {
        color: #CACACA;
      }
    }
    > span {
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
  .drop {
    position: absolute;
    top: 36px;
    z-index: 10;
    background: #FFFFFF;
    width: 100%;
    border-radius: 2px;
    // display: none;
    height: 0;
    transition: height 0.2s ease-out;
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    overflow-y: auto;
    > span {
      display: inline-block;
      width:100%;
      padding: 10px;
      color: #CCCCCC;
      text-align: center;
    }
    &.active {
      // display: block;
      height: 100px;
    }
    > li {
      text-align: center;
      padding: 10px;
      position: relative;
      &:active {
        background-color: #f2f3f5;
      }
      &.active {
        color: #FF9600;
      }
      &:after {
        position: absolute;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
  }
}
</style>